<template>
  <b-container fluid class="logo" v-bind:class="{ isOpen: visible }">
    <div class="logo-container"
         v-bind:class="{ isOpen: visible }">
      <div class="image-text" v-bind:class="{ isClosed: !visible }" v-on:click="goToHome">
        <img class="logo-image" :src="logo"/>
        <div class="text-container">
          <h2>Arthur Beaubois-Jude</h2>
          <h6 class="carte">Cartographie & Infographie</h6>
        </div>
      </div>
      <input id="responsive-menu" type="checkbox" v-model="visible">
      <label for="responsive-menu">
        <span id="menu-icon" class="d-md-none d-sm-flex m-auto"></span>
      </label>
      <!--<svg v-b-toggle.burger class="burger-menu d-md-none d-sm-flex mx-auto" fill="#000000"-->
           <!--xmlns="http://www.w3.org/2000/svg"-->
           <!--viewBox="0 0 24 24"-->
           <!--width="24px" height="24px">
           <path d="M 0 2 L 0 4 L 24 4 L 24 2 Z M 0 11 L 0 13 L 24 13 L-->
           <!--24 11 Z M 0 20L 0 22 L 24 22 L 24 20 Z"/></svg>-->
    </div>
    <div class="burger-menu-collapsed" v-bind:style="{display: visible ? 'flex' : 'none'}">
      <Navbar></Navbar>
    </div>
    <!--<b-collapse id="burger" v-model="visible" class="burger-menu-collapsed">-->
      <!--<Navbar></Navbar>-->
    <!--</b-collapse>-->
  </b-container>
</template>

<script>
import Navbar from '@/components/Navbar.vue';

function randomLogoUrl() {
  const logoNumber = Math.floor(Math.random() * 5) + 1;
  return `/assets/logo/logo-0${logoNumber}.jpg`;
}
export default {
  components: {
    Navbar,
  },
  name: 'Logo',
  data() {
    return {
      logo: randomLogoUrl(),
      visible: false,
    };
  },
  watch: {
    $route() {
      this.visible = false;
    },
  },
  methods: {
    goToHome() {
      this.$router.push('/').catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>

   .burger-menu-collapsed >>> nav {
    justify-content: space-evenly;
  }

  /* Hamburger Icon */
  #menu-icon,
  #menu-icon:before,
  #menu-icon:after {
    background: #1d1f20;
    border-radius: 0.05em;
    height: 0.2em;
    transition: all 0.2s ease-in-out;
    width: 100%;
  }

  #menu-icon {
    display: inline-block;
    margin: 0.4em 0;
    max-width: 1em;
    position: relative;
  }

  #menu-icon:before,
  #menu-icon:after {
    content: '';
    left: 0;
    position: absolute;
  }

  #menu-icon:before {
    top: -0.4em;
  }

  #menu-icon:after {
    bottom: -0.4em;
  }

  /* Close Icon */
  input[type=checkbox]:checked + label #menu-icon {
    background: transparent;
  }

  input[type=checkbox]:checked + label #menu-icon:before {
    top: 0;
    transform: rotate(-45deg);
  }

  input[type=checkbox]:checked + label #menu-icon:after {
    bottom: 0;
    transform: rotate(45deg);
  }

  input {
    display: none;
  }

  label {
    width: 100%;
    display: flex;
  }

    .logo {
      position: fixed;
      top: 0;
      z-index: 1000;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      &.isOpen {
        height: 100%;
        @media (min-width: 768px) {
          height: unset;
        }
    }

  .logo-container {
    @media (max-width: 768px) {
      &.isOpen {
       background-color: $color-white;
      }
    }
     height: fit-content;
     width: 100%;
     max-height: 122px;
     display: inline-flex;
    .image-text {
      @media (max-width: 768px) {
        padding-top: 6px;
      }
      max-width: 85%;
      cursor: pointer;
      display: inline-flex;
      padding-bottom: 10px;
      padding-right: 12px;
      background-color: $color-white;
      border-radius: 0 0 20px 20px;
      padding-left: 10px;
      &.isClosed {
        @media (max-width: 576px) {
          box-shadow: 0px 0px 8px 3px rgba(0, 0, 0, 0.25);
        }
      }
      .logo-image {
        max-width: 100px;
        height: auto;
        margin: auto 0;
        padding: 10px 0;
        @media (max-width: 768px) {
          padding: 0;
          max-width: 14vw;
          max-height: 50px;
          }
        }
      .text-container {
        @media (max-width: 576px) {
          font-size: 2.75vw;
          margin: auto 8px;
        }
        h2, h6 {
          margin-bottom: 0;
        }
        padding-bottom: 5px;
        white-space: nowrap;
        margin: auto 24px;
        text-align: justify;
        .carte {
          font-weight: $font-weight-light;
        }
      }
    }
    .burger-menu {
      margin: auto 5%;
      min-width: 1em;
      cursor: pointer;
    }
  }
  .burger-menu-collapsed {
    margin-left: -3rem;
    width: calc(100% + 6rem);
    justify-content: center;
    background-color: $color-white;
    margin-top: -7px;
    flex: 1;
    @media (min-width: 768px) {
      display: none !important;
    }
  }
  }
</style>
